
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Layout from "../../../components/Layout";
import Loader from "../../../components/Loader";
import PostPage from "../../../components/PostPage";
import { useGetPostsInPageQuery } from "../../../generated/graphql";
interface Props {
    isMobile: boolean;
    pageNum: number;
    offset: number;
    batchSize: number;
}
function ResultPage(props: Props) {
    const { isMobile, pageNum, offset, batchSize } = props;
    const { data: data, loading } = useGetPostsInPageQuery({
        variables: { offset: offset, size: batchSize },
    });
    const posts = data?.posts?.nodes || [];
    const totalPosts: NonNullable<number> = data?.posts?.pageInfo.offsetPagination?.total || 0;
    return (<Layout>
      <PostPage basePath="/" posts={posts} isMobile={isMobile} pageSelected={pageNum} totalPosts={totalPosts}/>
    </Layout>);
}
export default ResultPage;

    async function __Next_Translate__getServerSideProps__1976e6e07b1__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/page/[pageNum]/ResultPage',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1976e6e07b1__ as getServerSideProps }
  